module.exports = __webpack_public_path__ + "static/media/SM-MT-intro-mp3.4a65c4a9.mp3";